import { render, staticRenderFns } from "./userDashboardMembercard.vue?vue&type=template&id=6957dcd2"
import script from "./userDashboardMembercard.vue?vue&type=script&lang=js"
export * from "./userDashboardMembercard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports